import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd4b7fad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "panelEl",
  class: "nge-dataset-panel",
  role: "dialog",
  "aria-label": "Switch dataset"
}
const _hoisted_2 = { class: "nge-ds-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-ds-heading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-ds-title" }, "Switch Dataset"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-ds-sub" }, "Choose where to work. Production data is live science.")
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2 11.5V7M6.5 11.5V2.5M11 11.5V5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "square"
  })
], -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ds-stats-arrow",
  "aria-hidden": "true"
}, "›", -1 /* HOISTED */))
const _hoisted_6 = { class: "nge-ds-columns" }
const _hoisted_7 = { class: "nge-ds-section-head" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ds-section-dot",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "nge-ds-section-title" }
const _hoisted_10 = { class: "nge-ds-section-kicker" }
const _hoisted_11 = ["aria-expanded", "aria-label", "onClick"]
const _hoisted_12 = {
  key: 0,
  class: "nge-ds-help-text"
}
const _hoisted_13 = { class: "nge-ds-list" }
const _hoisted_14 = ["aria-expanded", "onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "nge-ds-card-text" }
const _hoisted_17 = { class: "nge-ds-card-label" }
const _hoisted_18 = { class: "nge-ds-card-desc" }
const _hoisted_19 = {
  key: 0,
  class: "nge-ds-origin"
}
const _hoisted_20 = {
  key: 1,
  class: "nge-ds-badge"
}
const _hoisted_21 = ["title", "aria-label"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-ds-chevron",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 4.5 6 8l3.5-3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "nge-ds-variants"
}
const _hoisted_25 = ["title", "aria-disabled", "onClick"]
const _hoisted_26 = { class: "nge-ds-variant-text" }
const _hoisted_27 = { class: "nge-ds-variant-label" }
const _hoisted_28 = { class: "nge-ds-card-desc" }
const _hoisted_29 = {
  key: 0,
  class: "nge-ds-request nge-ds-request--locked"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  class: "nge-ds-request"
}
const _hoisted_32 = {
  key: 0,
  class: "nge-ds-tag"
}
const _hoisted_33 = {
  key: 1,
  class: "nge-ds-tag nge-ds-badge--locked"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 2,
  class: "nge-ds-tag nge-ds-badge--view"
}
const _hoisted_36 = ["title", "aria-disabled", "onClick"]
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "nge-ds-card-text" }
const _hoisted_39 = { class: "nge-ds-card-label" }
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "nge-ds-card-desc" }
const _hoisted_42 = {
  key: 0,
  class: "nge-ds-origin"
}
const _hoisted_43 = {
  key: 1,
  class: "nge-ds-request nge-ds-request--locked"
}
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 2,
  class: "nge-ds-request"
}
const _hoisted_46 = {
  key: 3,
  class: "nge-ds-tasks"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ds-task-arrow",
  "aria-hidden": "true"
}, "›", -1 /* HOISTED */))
const _hoisted_49 = {
  key: 4,
  class: "nge-ds-tasks"
}
const _hoisted_50 = ["onClick", "title"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ds-task-arrow",
  "aria-hidden": "true"
}, "›", -1 /* HOISTED */))
const _hoisted_52 = ["onClick", "title"]
const _hoisted_53 = {
  key: 0,
  class: "nge-ds-task-n"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ds-task-arrow",
  "aria-hidden": "true"
}, "›", -1 /* HOISTED */))
const _hoisted_55 = ["onClick", "title"]
const _hoisted_56 = { class: "nge-ds-task-n" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-ds-task-arrow",
  "aria-hidden": "true"
}, "›", -1 /* HOISTED */))
const _hoisted_58 = {
  key: 1,
  class: "nge-ds-badge"
}
const _hoisted_59 = {
  key: 2,
  class: "nge-ds-badge nge-ds-badge--locked"
}
const _hoisted_60 = ["src"]
const _hoisted_61 = {
  key: 3,
  class: "nge-ds-badge nge-ds-badge--view"
}
const _hoisted_62 = {
  key: 0,
  class: "nge-ds-empty"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "nge-ds-screen",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($setup.emit('hide')), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            class: "nge-ds-stats-link",
            onClick: $setup.openDatasetStats,
            title: "What has been done on each dataset so far"
          }, [
            _hoisted_4,
            _createTextVNode(" Dataset stats"),
            _hoisted_5
          ]),
          _createElementVNode("button", {
            class: "nge-ds-close",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.COLUMNS, (col, ci) => {
            return _createElementVNode("div", {
              key: ci,
              class: _normalizeClass(["nge-ds-col", { 'nge-ds-col--prod': ci === 1 }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col, (sec) => {
                return (_openBlock(), _createElementBlock("section", {
                  key: sec,
                  class: _normalizeClass(["nge-ds-section", 'nge-ds-section--' + sec])
                }, [
                  _createElementVNode("header", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString($setup.SECTIONS[sec].title), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_10, _toDisplayString($setup.SECTIONS[sec].kicker), 1 /* TEXT */),
                    _createElementVNode("button", {
                      class: _normalizeClass(["nge-ds-help", { 'nge-ds-help--on': $setup.helpOpen === sec }]),
                      "aria-expanded": $setup.helpOpen === sec ? 'true' : 'false',
                      "aria-label": 'What is ' + $setup.SECTIONS[sec].title + '?',
                      onClick: $event => ($setup.toggleHelp(sec))
                    }, "?", 10 /* CLASS, PROPS */, _hoisted_11)
                  ]),
                  ($setup.helpOpen === sec)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString($setup.SECTIONS[sec].help), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardsIn(sec), (c) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: c.kind === 'group' ? 'g:' + c.key : c.ds.id
                      }, [
                        (c.kind === 'group')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["nge-ds-group", { 'nge-ds-group--open': $setup.openGroup === c.key }])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["nge-ds-card nge-ds-group-card", { 'nge-ds-active': $setup.groupActive(c) }]),
                                role: "button",
                                "aria-expanded": $setup.openGroup === c.key ? 'true' : 'false',
                                onClick: $event => ($setup.toggleGroup(c.key))
                              }, [
                                ($setup.DATASET_GROUPS[c.key].thumbnail)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: $setup.DATASET_GROUPS[c.key].thumbnail,
                                      class: "nge-ds-card-thumb",
                                      alt: "",
                                      loading: "lazy"
                                    }, null, 8 /* PROPS */, _hoisted_15))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, _toDisplayString($setup.DATASET_GROUPS[c.key].label), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_18, _toDisplayString($setup.DATASET_GROUPS[c.key].description), 1 /* TEXT */),
                                  ($setup.DATASET_GROUPS[c.key].origin)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, "From " + _toDisplayString($setup.DATASET_GROUPS[c.key].origin), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                ($setup.groupActive(c))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Active"))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("span", {
                                  class: "nge-ds-versions",
                                  title: `${c.members.length} versions`,
                                  "aria-label": `${c.members.length} versions`
                                }, _hoisted_23, 8 /* PROPS */, _hoisted_21)
                              ], 10 /* CLASS, PROPS */, _hoisted_14),
                              ($setup.openGroup === c.key)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.members, (ds) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: ds.id,
                                        class: _normalizeClass(["nge-ds-variant", {
                        'nge-ds-active': ds.id === $setup.currentDatasetId,
                        'nge-ds-switching': $setup.switching,
                        'nge-ds-locked': $setup.accessOf(ds) === 'none',
                      }]),
                                        title: $setup.accessOf(ds) === 'none' ? $setup.lockedTip : $setup.accessOf(ds) === 'view' ? $setup.viewTip : undefined,
                                        "aria-disabled": $setup.accessOf(ds) === 'none' ? 'true' : undefined,
                                        onClick: $event => ($setup.switchTo(ds))
                                      }, [
                                        _createElementVNode("div", _hoisted_26, [
                                          _createElementVNode("div", _hoisted_27, _toDisplayString(ds.variantLabel || ds.label), 1 /* TEXT */),
                                          _createElementVNode("div", _hoisted_28, _toDisplayString(ds.description), 1 /* TEXT */),
                                          ($setup.accessOf(ds) === 'none' && $setup.needsRetinaFirst(ds))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                _createElementVNode("img", {
                                                  src: $setup.lockIcon,
                                                  class: "nge-ds-lock",
                                                  alt: "",
                                                  "aria-hidden": "true"
                                                }, null, 8 /* PROPS */, _hoisted_30),
                                                _createTextVNode(" Unlock Level 1 (Retina) before moving to " + _toDisplayString(ds.shortLabel || ds.label) + ".", 1 /* TEXT */)
                                              ]))
                                            : ($setup.accessOf(ds) === 'none')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                  _createVNode($setup["RequestAccessButton"], { ds: ds }, null, 8 /* PROPS */, ["ds"])
                                                ]))
                                              : _createCommentVNode("v-if", true)
                                        ]),
                                        (ds.id === $setup.currentDatasetId)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Active"))
                                          : ($setup.accessOf(ds) === 'none')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                _createElementVNode("img", {
                                                  src: $setup.lockIcon,
                                                  class: "nge-ds-lock",
                                                  alt: "",
                                                  "aria-hidden": "true"
                                                }, null, 8 /* PROPS */, _hoisted_34),
                                                _createTextVNode(" No access")
                                              ]))
                                            : ($setup.accessOf(ds) === 'view')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, "View only"))
                                              : _createCommentVNode("v-if", true)
                                      ], 10 /* CLASS, PROPS */, _hoisted_25))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([c.ds], (ds) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: ds.id,
                                class: _normalizeClass(["nge-ds-card", {
                    'nge-ds-active': ds.id === $setup.currentDatasetId,
                    'nge-ds-switching': $setup.switching,
                    'nge-ds-locked': $setup.accessOf(ds) === 'none',
                  }]),
                                title: $setup.accessOf(ds) === 'none' ? $setup.lockedTip : $setup.accessOf(ds) === 'view' ? $setup.viewTip : undefined,
                                "aria-disabled": $setup.accessOf(ds) === 'none' ? 'true' : undefined,
                                onClick: $event => ($setup.switchTo(ds))
                              }, [
                                (ds.thumbnail)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: ds.thumbnail,
                                      class: "nge-ds-card-thumb",
                                      alt: "",
                                      loading: "lazy"
                                    }, null, 8 /* PROPS */, _hoisted_37))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _createTextVNode(_toDisplayString(ds.label), 1 /* TEXT */),
                                    (ds.level)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "nge-ds-level",
                                          title: ds.level === 1 ? 'Level 1: unlocked with retina edit access' : `Level ${ds.level}: ask for it once Level ${ds.level - 1} is unlocked`
                                        }, "Level " + _toDisplayString(ds.level), 9 /* TEXT, PROPS */, _hoisted_40))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(ds.description), 1 /* TEXT */),
                                  (ds.origin)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, "From " + _toDisplayString(ds.origin), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  ($setup.accessOf(ds) === 'none' && $setup.needsRetinaFirst(ds))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        _createElementVNode("img", {
                                          src: $setup.lockIcon,
                                          class: "nge-ds-lock",
                                          alt: "",
                                          "aria-hidden": "true"
                                        }, null, 8 /* PROPS */, _hoisted_44),
                                        _createTextVNode(" Unlock Level 1 (Retina) before moving to " + _toDisplayString(ds.shortLabel || ds.label) + ".", 1 /* TEXT */)
                                      ]))
                                    : ($setup.accessOf(ds) === 'none')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                          _createVNode($setup["RequestAccessButton"], { ds: ds }, null, 8 /* PROPS */, ["ds"])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                  _createCommentVNode(" The Sandbox: one way in, the tutorial you are on (Ames 2026-10-28). "),
                                  (ds.section === 'sandbox')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _createElementVNode("button", {
                                          class: "nge-ds-task",
                                          onClick: _withModifiers($setup.startHere, ["stop"]),
                                          title: "Open the tutorial you are on, or the next one"
                                        }, [
                                          _createTextVNode(" Start here"),
                                          _hoisted_48
                                        ], 8 /* PROPS */, _hoisted_47)
                                      ]))
                                    : ($setup.showTasks(ds))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                          (ds.cellTasks)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "nge-ds-task",
                                                onClick: _withModifiers($event => ($setup.openTask(ds, 'available')), ["stop"]),
                                                title: 'Open the Cell Library on the cells nobody has claimed yet' + (ds.id === $setup.currentDatasetId ? '' : ', after switching here')
                                              }, [
                                                _createTextVNode(" Available cells"),
                                                _hoisted_51
                                              ], 8 /* PROPS */, _hoisted_50))
                                            : _createCommentVNode("v-if", true),
                                          ($setup.hasQuests(ds))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "nge-ds-task",
                                                onClick: _withModifiers($event => ($setup.openTask(ds, 'quests')), ["stop"]),
                                                title: 'Open the Quests: mark the cilia on a starburst amacrine cell' + (ds.id === $setup.currentDatasetId ? '' : ', after switching here')
                                              }, [
                                                _createTextVNode(" Quests"),
                                                ($setup.questCount)
                                                  ? (_openBlock(), _createElementBlock("b", _hoisted_53, _toDisplayString($setup.questCount) + " open", 1 /* TEXT */))
                                                  : _createCommentVNode("v-if", true),
                                                _hoisted_54
                                              ], 8 /* PROPS */, _hoisted_52))
                                            : _createCommentVNode("v-if", true),
                                          (ds.cellTasks && $setup.claimsOn(ds))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "nge-ds-task nge-ds-task--in",
                                                onClick: _withModifiers($event => ($setup.openTask(ds, 'mine')), ["stop"]),
                                                title: 'Open the Cell Library on the cells you have claimed here' + (ds.id === $setup.currentDatasetId ? '' : ', after switching here')
                                              }, [
                                                _createTextVNode(" My cells"),
                                                _createElementVNode("b", _hoisted_56, _toDisplayString($setup.claimsOn(ds)), 1 /* TEXT */),
                                                _hoisted_57
                                              ], 8 /* PROPS */, _hoisted_55))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                ]),
                                (ds.id === $setup.currentDatasetId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, "Active"))
                                  : ($setup.accessOf(ds) === 'none')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                        _createElementVNode("img", {
                                          src: $setup.lockIcon,
                                          class: "nge-ds-lock",
                                          alt: "",
                                          "aria-hidden": "true"
                                        }, null, 8 /* PROPS */, _hoisted_60),
                                        _createTextVNode(" No access")
                                      ]))
                                    : ($setup.accessOf(ds) === 'view')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, "View only"))
                                      : _createCommentVNode("v-if", true)
                              ], 10 /* CLASS, PROPS */, _hoisted_36))
                            }), 128 /* KEYED_FRAGMENT */))
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (!$setup.cardsIn(sec).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, "Nothing here yet."))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */)
          }), 64 /* STABLE_FRAGMENT */))
        ])
      ], 512 /* NEED_PATCH */)
    ])
  ]))
}